import { HTTP } from '@/lib/http/client';
import WasteType from '@/models/wasteTypes';

export default class WasteTypesApi {
  static async getAll(): Promise<WasteType[]> {
    const res = await HTTP.get('wastetypes');
    return res.data;
  }
}
